export function preload() {
	var body = document.querySelector('body')
	if (body.classList.contains('preload')) {
		body.classList.remove('preload')
	} else {
		setTimeout(preload, 500)
	}
}
